import React from "react";
import { useTranslation } from "react-i18next";

import { Button, Tooltip } from "antd";
import { QrcodeOutlined } from "@ant-design/icons";

import { API_URL } from "../../shared/utils/Util";
import { useNotification } from "../../shared/hooks";
import { downloadFile, slugify } from "./download";

type TableQRCodeButtonProps = {
  restaurantId: string;
  table_id: string;
  table_name: string;
};

// TableQRCodeButton downloads a single table's plain QR code (PNG). The image
// is generated on click rather than eagerly for every row on page load.
export const TableQRCodeButton = (props: TableQRCodeButtonProps) => {
  const { t } = useTranslation();
  const { showError } = useNotification();
  const [loading, setLoading] = React.useState(false);

  const onClick = async () => {
    setLoading(true);
    try {
      await downloadFile(
        `${API_URL}/v1/r/${props.restaurantId}/tables/${props.table_id}/qrcode`,
        `${slugify(props.table_name)}.png`,
        "image/png"
      );
    } catch (err) {
      showError(t("failed_to_download_qr_code"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title={t("download_qr_code")}>
      <Button shape="circle" icon={<QrcodeOutlined />} loading={loading} onClick={onClick} />
    </Tooltip>
  );
};
